import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_mst_label_list_hdr_RowClass } from '../../../dbschema/bl_inv_mst_label_list_hdr.model';

export class InventoryLabelListContainerModel extends BaseContainerModel {
  bl_inv_mst_label_list_hdr: bl_inv_mst_label_list_hdr_RowClass = new bl_inv_mst_label_list_hdr_RowClass();
}
